import React, { useEffect } from 'react';
import axios from '../../../Helpers/Axiosbase'
import { Card, CardHeader, CardContent, Checkbox, TextField, Button, Switch, FormGroup, FormControlLabel, FormControl, CardActions } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux'
import useReactRouter from 'use-react-router';
import { makeStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { LinearProgress,Snackbar } from '@material-ui/core';
import { useInputChange } from '../../../Helpers/useInputChange'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import * as actions from '../../../Store/Actions'

import MuiAlert from '@material-ui/lab/Alert';
var md5 = require('md5');

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
// var ReverseMd5 = require('reverse-md5');

const useStyles = makeStyles(theme => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: 200,
        },
    },
    div: {
        float: 'left',
        overflow: 'hidden'
    }
}));

export default function UserManage(props) {
    const [showProgress, setShowProgress] = React.useState(false);
    const [selectEnvironments, setSelectEnvironments] = React.useState([]);
    const [userEnvironments, setUserEnvironments] = React.useState([]);
    const [defaultEnvironment, setDefaultEnvironment] = React.useState([]);
    const [disabled, setDisabled] =React.useState(false);

    const reduxAuth = useSelector((state) => state.auth)
    const dispatch = useDispatch();

    const { location, history } = useReactRouter();


    const [input, handleInputChange, handleSwitchChange, setInput] = useInputChange({
        username: "",
        password: "",
        isActive: true,
        isAdmin: false,
        environments:{ value :[]},
        defaultEnvironment: ""
    });
    const [errorMessage,setErrorMessage]=React.useState({
        open:false,
        errmsg:null,
      });

      const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
      };
    const onCancleClickHandler = () =>{
        history.push("/user")
    }

    var onSubmitClickHandler = () => {
        setShowProgress(true);
        input.environments.value=userEnvironments.map((currentValue, index) => {
            return currentValue._id;
        })
       
        input.defaultEnvironment = defaultEnvironment._id ? defaultEnvironment._id : {};
        // input.password=md5(input.password);
        // console.log(input);
        let url = "getAll"
        url = input._id ? "userUpdate" : "userCreate";
        input.password=input._id?input.password:md5(input.password);
        // console.log(input);
        axios.post(url, { ...input, token: reduxAuth.token, userId: reduxAuth.userId })
            .then(response => {
                history.push('/user');
            })
            .catch(err => {
                if(typeof err.response!="object")
                {
                  setErrorMessage({
                    open:true,
                    // errmsg:err
                  })
                  console.log(err);
                }
                else 
                {
                if (err.response.status === 403) {
                    setShowProgress(false);
                    dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
                }
            }
            });
    }

    var autoSelectChangeHandler = (event, value) => {
        if (event.currentTarget.id.includes("select-environment")) {
            setUserEnvironments(value);
        }
        if (event.currentTarget.id.includes("default-environment")) {
            setDefaultEnvironment(value);
        }
    }

    var getEnvironment = () => {
        let url = "getAll"
        let postdata = { objectName: "environment", token: reduxAuth.token, userId: reduxAuth.userId }
        axios.post(url, postdata)
            .then(response => {
                setSelectEnvironments(response.data.response);
                setShowProgress(false);
                if (location.state) {
                    //Set Default Environment
                    var defaultEnvironmentValue = response.data.response.filter((environment) => { return location.state.defaultEnvironment === environment._id })
                    defaultEnvironmentValue = defaultEnvironmentValue.length > 0 ? defaultEnvironmentValue[0] : {};
                    setDefaultEnvironment(defaultEnvironmentValue);

                    //Set Selected Environments
                    const selectedEvironmentValues = response.data.response.filter((environment) => {
                        return location.state.environments.value.some((selectedEnvironment) => {
                            return environment._id === selectedEnvironment;
                        });
                    });
                    setUserEnvironments(selectedEvironmentValues);
                }
            })
            .catch(err => {
                if(typeof err.response!="object")
                {
                  setErrorMessage({
                    open:true,
                    // errmsg:err
                  })
                  console.log(err);
                }
                else 
                {
                if (err.response.status === 403) {
                    setShowProgress(false);
                    dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
                } else {
                    setShowProgress(false);
                }
            }
            });
    }

    useEffect(() => {
        setShowProgress(true);
        getEnvironment();
        // console.log(location.state);
        if (location.state) {
            setDisabled(true);
            setInput(location.state);
        }
    }, []);

    const classes = useStyles();

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    return (

        <div>
            <Snackbar
                open={errorMessage.open} autoHideDuration={3000} anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                onClose={handleClose}>
                    <Alert 
                    severity="error"
                    color="error"
                    variant="filled">
                    {errorMessage.errmsg!=null?errorMessage.errmsg:" NetWork Error:Please Check Your Internet Connection"}
                    </Alert>
            </Snackbar>
            {showProgress ? <LinearProgress /> : null}
            <Card>
                <CardHeader title="Manage User" />
                <CardContent >
                    <form className={classes.root} autoComplete="off">
                        <div>
                            <TextField name="username" id="username" variant="outlined" style={{ width: 250 }} label="Username" onChange={(event) => handleInputChange(event)} value={input.username} />
                            <TextField name="password" id="password" variant="outlined" style={{ width: 250 }} label="Password" type="password" onChange={(event) => handleInputChange(event)} value={input.password} disabled={disabled}/>
                        </div>
                        <div>
                            <FormControlLabel
                                control={<Switch name="isAdmin" checked={input.isAdmin}
                                    onChange={() => handleSwitchChange('isAdmin')} color="primary" />
                                }
                                label="Is Admin?" />
                            <FormControlLabel
                                control={<Switch name="isActive" checked={input.isActive}
                                    onChange={() => handleSwitchChange('isActive')} color="primary" />
                                }
                                label="Is Active?" />
                        </div>
                        <div >
                            <Autocomplete
                                multiple
                                id="select-environment"
                                name="environment"
                                options={selectEnvironments}
                                onChange={autoSelectChangeHandler}
                                disableCloseOnSelect
                                getOptionLabel={option => option.displayName}
                                renderOption={(option, { selected }) => (
                                    <React.Fragment>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.displayName}
                                    </React.Fragment>
                                )}
                                style={{ width: 250 }}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Environments"
                                        placeholder="Environments"
                                        fullWidth
                                    />
                                )}
                                value={userEnvironments}
                            />
                            <Autocomplete
                                id="default-environment"
                                options={selectEnvironments}
                                onChange={autoSelectChangeHandler}
                                disableCloseOnSelect
                                getOptionLabel={option => option.displayName}
                                renderOption={(option, { selected }) => (
                                    <React.Fragment>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.displayName}
                                    </React.Fragment>
                                )}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Default Environment"
                                        placeholder="Environments"
                                        fullWidth
                                    />
                                )}
                                value={defaultEnvironment}
                            />
                        </div>
                        <CardActions>
                            <Button color="primary" variant="contained" onClick={onSubmitClickHandler}>Submit</Button>
                            <Button color="secondary" variant="contained" onClick={onCancleClickHandler}>Cancle</Button>
                        </CardActions>
                    </form>
                </CardContent>
            </Card>
        </div>
    );
}